module.exports = __webpack_public_path__ + "static/media/language.91044b5f.svg";